module.exports = __webpack_public_path__ + "img/调度.04531de6.jpg";